<template>
  <div
    v-if="loading"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div class="spinner mx-auto"></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>
  <div v-else class="overflow-x-hidden">
    <BaseModal
      :showModal="showDeleteModal"
      v-on:close="showDeleteModal = false"
      v-on:confirm="
        deleteSurvey(idToDelete);
        showDeleteModal = false;
      "
    >
      <template v-slot:body>
        <p class="text-sm text-gray-500">
          <strong>
            Warning: you will lose any existing responses you have received for
            this survey.
          </strong>
          <br />

          Are you sure you want to delete this survey and lose existing
          responses? This action cannot be undone.
        </p>
      </template>
    </BaseModal>

    <div class="">
      <header-notification></header-notification>

      <Navbar
        id="header"
        class="bg-white border-b border-solid border-gray-200 opacity-100 py-2 px-10 shadow"
      >
      </Navbar>

      <h1 class="px-16 mt-10 text-xl text-gray-600 font-bold">
        Custom Integrations
      </h1>

      <div class="max-w-5xl flex flex-wrap -mx-2 mt-20 px-10">
        <div
          v-for="(integration, index) in integrations"
          :key="index"
          class="w-96 px-2"
          style="min-height:245px"
        >
          <div
            class="bg-white rounded-lg shadow-md hover:cursor-pointer mb-6 p-10 rounded h-100 flex flex-col"
          >
            <span
              class="material-icons text-gray-400 mx-auto"
              style="font-size:65px"
            >
              cloud_upload
            </span>

            <div class="text-xl mx-auto py-3">Webhook</div>

            <div class="mx-auto py-3">
              Use webhooks to integrate Appflowz with your application or third
              party app
            </div>
            <div class=" mx-auto">
            <router-link
              :to="{name: 'webhooks'}"
              class="py-3 mr-2 hover:text-white hover:no-underline block bg-blue-800 hover:bg-blue-600 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-3 rounded-md shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
              type="button"
              style="transition: all .15s ease"
            >
              Configure Webhook
            </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Header.vue";
import HeaderNotification from "@/components/HeaderNotification.vue";
import router from "@/router/route.js";

export default {
  components: {
    Navbar,
    HeaderNotification,
  },
  data() {
    return {
      integrations: [
        {
          name: "Webhook",
          route: "webhook",
        },
      ],
      loading: false,
      showDeleteModal: false,
      idToDelete: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {},
  created() {},
  watch: {},
};
</script>

<style></style>
